<template>
  <v-card justify="center" align="center" class="mt-2 pa-4">
    <v-row>
      <v-col cols="12" md="4"
        ><h3>
          <v-icon>{{ props.icono }}</v-icon
          ><small>{{ props.cantidad }}</small>
          {{ props.descripcion }}
        </h3></v-col
      >
      <v-col cols="6"
        ><h2>
          {{ props.monto }}
        </h2></v-col
      >
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "TarjetaDetalle",
  props: {
    props: {
      type: Object,
      default: () => ({
        icono: "",
        cantidad: 0,
        descripcion: "",
        monto: 0,
      }),
    },
  },
};
</script>
